module.exports = __webpack_public_path__ + "media/images/flags/bf-468af801120c21b0cfb02da5302a1ccf.svg";